import { Dialog } from '@headlessui/react';
import { useUser } from '@clerk/clerk-react';

interface ContractorAccountModalProps {
  open: boolean;
  onClose: () => void;
}

export default function ContractorAccountModal({ open, onClose }: ContractorAccountModalProps) {
  const { user } = useUser();

  if (!user || user.publicMetadata.accountType !== 'contractor') return null;

  return (
    <Dialog open={open} onClose={onClose} className="fixed z-50 inset-0 flex items-center justify-center">
      <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
      <Dialog.Panel className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full z-10">
        <h2 className="text-xl font-semibold mb-4">Manage Contractor Account</h2>
        <div className="mt-4">
          <p><strong>Business Name:</strong> {user.publicMetadata.businessName || 'Not set'}</p>
          <p><strong>Email:</strong> {user.emailAddresses[0]?.emailAddress}</p>
          <p><strong>EIN:</strong> {user.publicMetadata.ein || 'Not set'}</p>
          {/* Add inputs to update fields if needed */}
        </div>
        <button className="mt-4 btn btn-secondary" onClick={onClose}>Close</button>
      </Dialog.Panel>
    </Dialog>
  );
} 